import { BaseApi } from './base.api.js';

export class InternationalTransferApi extends BaseApi {
    constructor(client) {
        super(client, '/international-transfer');
    }
}
